/**
 * Utility class to log errors.
 * Install any error client package like lincd-sentry in your app to log errors.
 */
export class LinkedErrorLogging {
    static setDefaultLogger(logger) {
        this.logger = logger;
    }
    static hasDefaultLogger() {
        return this.logger && true;
    }
    static log(error) {
        if (this.logger) {
            return this.logger.log(error);
        }
    }
}
//# sourceMappingURL=LinkedErrorLogging.js.map